module.exports = __webpack_public_path__ + "static/media/calendar.8127bdfb.svg";